import { FC } from 'react';

import { Close, Edit2Line } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

import { StyledBurger } from '../styled';

export interface IHeaderUserMenu {
  isOpen: boolean;
  toogleMenuOpen: () => void;
}

const HeaderSearch: FC<IHeaderUserMenu> = ({ isOpen, toogleMenuOpen }) => (
  <StyledBurger isOpen={isOpen} onClick={toogleMenuOpen}>
    {isOpen === true ? (
      <CustomIcon icon={Close} paletteColor='whiteAlpha600' />
    ) : (
      <CustomIcon fontSize={24} icon={Edit2Line} paletteColor='whiteAlpha600' />
    )}
  </StyledBurger>
);

export default HeaderSearch;
